import { getBaseUrl } from "./base_url"
import { ExactagData } from "@otto-ec/online-marketing/dist-lib/exactag/core/data"

enum RequestMethod {
    get = "GET",
}

async function fetchJSON(url: string, method: RequestMethod): Promise<any> {
    const response = await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        return null
    }
    return response.json()
}

export async function fetchExactagCustomerData(): Promise<ExactagData | null> {
    const baseUrl = getBaseUrl(document)
    return await fetchJSON(`${baseUrl}/tags`, RequestMethod.get)
}
